module.exports = __webpack_public_path__ + "img/illustration.bb7968be.png";